module.exports = __webpack_public_path__ + "media/images/heading-ca14cf763f714dd65a390569e70ad457.svg";